import { render, staticRenderFns } from "./SnackbarController.vue?vue&type=template&id=3335a2be&scoped=true"
import script from "./SnackbarController.vue?vue&type=script&lang=js"
export * from "./SnackbarController.vue?vue&type=script&lang=js"
import style0 from "./SnackbarController.vue?vue&type=style&index=0&id=3335a2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3335a2be",
  null
  
)

export default component.exports